import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import DesktopMenu from './DesktopMenu';
import GumroadFollowForm from './GumroadFollowForm';
import GumroadProducts from './GumroadProducts';
import Footer from './Footer';
import membershipCover from '../images/membership_cover.png';
import creativeSignalRitualCover from '../images/creative_signal_ritual_cover.png';
import strategyOfFutunessCover from '../images/strategy_gr.png';
import theContainerCover from '../images/gumroad_cover_container.png';

const products = [
    {
        name: 'Spectral Center Membership',
        path: '/membership',
        blurb: 'Ongoing access to the full library of recordings, workshops, and monthly releases.',
        image: membershipCover
    },
    {
        name: 'Creative Signal Ritual',
        path: '/creative-signal-ritual',
        blurb: 'A 21-day practice for reducing interference and training your capacity to receive ideas.',
        image: creativeSignalRitualCover
    },
    {
        name: 'The Strategy of Futureness',
        path: '/strategy-of-futureness',
        blurb: 'A 4-week workshop using hypnosis and visionary fiction to build a working relationship with a future self.',
        image: strategyOfFutunessCover
    },
    {
        name: 'The Container',
        path: '/the-container',
        blurb: 'A deep-dive ritual for clarity, boundaries, and self-trust.',
        image: theContainerCover
    }
]

const Shop = () => {
    return (
        <>
            <Navbar/>
            <DeskWrap>
                <DesktopMenu/>
                <ContentWrapper>
                    <ProductsSection>
                        <H1>Self-Hypnosis & Digital Rituals</H1>
                        <ProductGrid>
                            {products.map((p) => (
                                <ProductCard as={Link} to={p.path} key={p.path}>
                                    <ProductImage src={p.image} alt={p.name} />
                                    <ProductName>{p.name}</ProductName>
                                    <ProductBlurb>{p.blurb}</ProductBlurb>
                                </ProductCard>
                            ))}
                        </ProductGrid>
                    </ProductsSection>
                    <FreeResourcesSection>
                        <H1>Free Resources</H1>
                        <GumroadProducts tag="free" />
                    </FreeResourcesSection>
                    <NewsletterSection>
                        <H2>Sign up for the newsletter for a free self-hypnosis recording</H2>
                        <Form>
                            <GumroadFollowForm/>
                        </Form>
                    </NewsletterSection>
                </ContentWrapper>
            </DeskWrap>
            <Footer/>
        </>
    )
}

const DeskWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;

    @media (min-width: 1000px) {
        flex-direction: row;
    }
`

const ContentWrapper = styled.div`
    width: 90%;
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    @media (min-width: 1000px) {
        padding: 2rem;
        margin-right: 2rem;
        gap: 2.5rem;
    }
`

const ProductsSection = styled.div`
    width: 100%;
`

const FreeResourcesSection = styled.div`
    width: 100%;
`

const ProductGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-top: 1rem;

    @media (min-width: 700px) {
        grid-template-columns: 1fr 1fr;
    }
`

const ProductCard = styled.div`
    display: block;
    border: 1px solid #eee;
    border-radius: 0.5rem;
    padding: 1.25rem;
    text-decoration: none;
    color: inherit;
    transition: border-color 0.2s ease;
        max-width: 400px;

    &:hover {
        border-color: #333;
    }
`

const ProductImage = styled.img`
    width: 100%;
    border-radius: 0.35rem;
    display: block;
    margin: 0 0 0.75rem;
`

const ProductName = styled.p`
    font-weight: 600;
    font-size: 1.1rem;
    color: #333;
    margin: 0 0 0.4rem;
`

const ProductBlurb = styled.p`
    font-size: 0.9rem;
    line-height: 1.6;
    color: #444;
    margin: 0;
`

const NewsletterSection = styled.div`
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.5rem;

    @media (min-width: 768px) {
        padding: 1rem;
    }
`

const H1 = styled.h1`
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: #333;
    line-height: 1.4;

    @media (min-width: 1000px) {
        font-size: 1.8rem;
    }
`

const H2 = styled.h2`
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #333;
    line-height: 1.4;
    padding: 0 0.5rem;

    @media (min-width: 768px) {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
        padding: 0;
    }
`

const Form = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.5rem 0;

    @media (min-width: 768px) {
        margin: 1rem 0;
    }
`

export default Shop;